<template>
  <div class="base-card-item" :class="{'base-card--with-background': backgroundImage}">
    <div class="base-card-image">
      <picture
        v-lazyload="{ src: imageUrl, variant: 'resort-card' }"
        class="wrapper"
      >
        <img
          class="image"
          src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
          :alt="imageAlt"
        />
      </picture>
      <div v-if="label" class="base-card-label">
        {{ label }}
      </div>
    </div>
    <div class="base-card-content">
      <slot name="content" />
    </div>
    <div class="base-card-utility">
      <slot name="additional-info" />
      <div class="base-card-ctas">
        <slot name="ctas" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseCard",
  components: {},
  props: {
    imageUrl: {
      type: String,
      required: true,
    },
    imageAlt: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    backgroundImage: {
      type: Boolean,
      required: false,
      default: () => {
        return false
      }
    }
  },
};
</script>
